$(document).ready(function () {
    var productGridItem = $('.product-wrap')

    if (productGridItem) {
        for (var i = 0; i < productGridItem.length; i++) {
            var currentItem = productGridItem[i]
            var bgColor = ''
            var fontColor = ''
            var tagText = ''
            var badge = ''

            if ($(currentItem).data('bgcolor')) {
                bgColor = $(currentItem).data('bgcolor')
            }

            if ($(currentItem).data('fontcolor')) {
                fontColor = $(currentItem).data('fontcolor')
            }

            if ($(currentItem).data('tagtext')) {
                tagText = $(currentItem).data('tagtext')
            }

            // reg ex to determine if string is a valid hex color
            var hexRegEx = new RegExp('^#(?:[0-9a-f]{3}){1,2}$', 'i')

            // if adding a # before the color string makes it a valid hex color, 
            // then append # to the color string
            if (hexRegEx.test(`#${bgColor}`)) {
                bgColor = '#' + bgColor
            }

            if (hexRegEx.test(`#${fontColor}`)) {
                fontColor = '#' + fontColor
            }

            // create HTML element and add to DOM
            if (bgColor != '' && fontColor != '') {
                badge = `<span style='background-color: ${bgColor}; color: ${fontColor};' class="sale__tag">`
                badge += tagText + '</span>'
            }

            $(currentItem).prepend(badge)
        }
    }
})